import React               from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Combobox            from "@shared/combobox"

export const Partner = ({ partners, workorderState, setWorkorderState }) => {
  if (!partners || partners.length === 0) return null

  const lockedId = workorderState.clientPartnerId

  return (
    <div className='form-group'>
      <label required>
        { I18n.t("partners.issuing_partner") }
      </label>
      { lockedId && <span className="ml-1" tooltip={ I18n.t("partners.locked_hint") }><FontAwesomeIcon icon="info-circle" /></span> }

      <Combobox
        prompt          = { I18n.t("client.partners.select_partner") }
        options         = { partners }
        onSelectElement = { partner => setWorkorderState({ partnerId: partner.id || null }) }
        value           = { lockedId || workorderState.partnerId }
        disabled        = { !!lockedId }
        required
      />
    </div>
  )
}
